import { Expose, Transform } from "class-transformer";
import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { toEuros } from "@/utils/numberUtils";

export class PointPriceConfigurationDto extends BaseEntityDto {
  @Expose()
  points: number;

  @Expose()
  @Transform(({ value }) => toEuros(value, false))
  technicianPriceCents: number;

  @Expose()
  @Transform(({ value }) => toEuros(value, false))
  driverPriceCents: number;

  @Expose()
  @Transform(({ value }) => toEuros(value, false))
  assistantPriceCents: number;
}
